import type { HeartRateDashboardComponentProps } from './HeartRateDashboardComponent';

export const HeartRateDashboardComponent = {
  MountAsync: async (target: HTMLElement, props: HeartRateDashboardComponentProps) => {
    const { mountReactComponentAsync } = await import('../mountReactComponentAsync');
    const { HeartRateDashboardComponent } = await import('./HeartRateDashboardComponent');
    return await mountReactComponentAsync(target, HeartRateDashboardComponent, props);
  }
};